import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";

const MFAForm = ({
  onSubmit,
  classes,
  errorMessage,
  open,
  setErrorMessage,
  handleChangeLocation,
}) => (
  <Formik
    initialValues={{ code: "" }}
    validationSchema={Yup.object().shape({
      code: Yup.string()
        .matches(/^\d+$/, "Code must contain only numbers")
        .min(6, "Code must be at least 6 digits")
        .max(8, "Code must be at most 8 digits")
        .required("Verification code is required"),
    })}
    onSubmit={onSubmit}
  >
    {({
      errors,
      handleBlur,
      handleChange,
      handleSubmit,
      touched,
      values,
      isValid,
      dirty,
    }) => (
      <form noValidate onSubmit={handleSubmit} className={classes.formStyle}>
        <TextField
          error={Boolean(touched.code && errors.code)}
          fullWidth
          helperText={touched.code && errors.code}
          label="Verification Code"
          margin="normal"
          name="code"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.code}
          variant="outlined"
          placeholder="Enter 6-digit code"
          inputProps={{
            maxLength: 8,
            pattern: "[0-9]*",
            inputMode: "numeric"
          }}
        />
        <Box mt={2}>
          <Button
            color="primary"
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            disabled={!isValid || !dirty} // Button is disabled if the form is invalid or untouched
          >
            Verify Code
          </Button>
        </Box>
        <Box mt={2} className={classes.backButtonContainer}>
          <Button
            size="small"
            variant="text"
            onClick={() => handleChangeLocation("login")}
            className={classes.backButton}
          >
            Back to Login
          </Button>
        </Box>
      </form>
    )}
  </Formik>
);

export default MFAForm;